<div
  class="side-panel vertical"
  [class.is-open]="isOpen"
  [ngClass]="width ? 'side-panel-' + width : null"
>
  <div class="modal-content">
    <div class="modal-header" (window:keydown.esc)="onEscapeKey()">
      <h4 class="modal-title">
        <h3 class="mb-0">{{ heading }}</h3>
      </h4>

      <button
        class="btn-close"
        type="button"
        aria-label="Close"
        [hidden]="!isOpen"
        [disabled]="closeDisabled"
        (click)="close()"
      ></button>
    </div>
    <div cdkVirtualScrollingElement class="panel-content flex-grow-1 vertical">
      <div class="p-4 flex-grow-1">
        <ng-container #sidePanel></ng-container>
      </div>
    </div>
  </div>
</div>
